<template>
  <BasicAlert
    alertLabel="Les champs avec * sont obligatoires."
    class="form--mandatory"
  />
  <RechercheFormation />
  <ChoixTypeModule />
  <BasicRedirection
    :show-if="!!moduleEnCours"
    :after-scroll-delay="400"
    @after-scroll="définirModuleEnCours(null)"
  >
    <template #topAnchor>
      <ListeModules />
    </template>
    <template #bottomAnchor>
      <Module />
    </template>
  </BasicRedirection>
</template>

<script setup lang="ts">
  import RechercheFormation from './sections/recherche/RechercheFormationSection.vue'
  import ListeModules from './sections/list/ListeModulesSection.vue'
  import Module from './sections/module/ModuleSection.vue'
  import ChoixTypeModule from './modal/ChoixTypeModule.vue'
  import { inject } from 'vue'
  import { PROA_MODULES_ACTIONS } from './useModuleActions'

  const { moduleEnCours, définirModuleEnCours } = inject(PROA_MODULES_ACTIONS)!
</script>
